// This is an empty "theme" that is needed to be able to configure
// storybook with arbitrary number of user supplied themes
export const Theme = {
  name: undefined
};

export const breakpoints = {};

export const ThemeProvider = {};
